import styled, { css } from 'styled-components';

const HelperText = styled.div`
  position: absolute;
  right: 0;
  bottom: .75rem;
  left: 0;

  ${props => props.styles && css`
    ${props.styles}
  `}

  p {
    margin: 0;
    line-height: 1;
    font-size: .75rem;
    font-weight: 600;
  }
`;

HelperText.Text = styled.p`
  opacity: .6;
`;

HelperText.Error = styled.p`
  color: ${props => props.theme.error};
`;

export default HelperText;
